/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicMatchOperationV2Participants } from './PublicMatchOperationV2Participants';
import {
    PublicMatchOperationV2ParticipantsFromJSON,
    PublicMatchOperationV2ParticipantsFromJSONTyped,
    PublicMatchOperationV2ParticipantsToJSON,
    PublicMatchOperationV2ParticipantsToJSONTyped,
} from './PublicMatchOperationV2Participants';
import type { PublicMatchOperationV2ActiveSuspension } from './PublicMatchOperationV2ActiveSuspension';
import {
    PublicMatchOperationV2ActiveSuspensionFromJSON,
    PublicMatchOperationV2ActiveSuspensionFromJSONTyped,
    PublicMatchOperationV2ActiveSuspensionToJSON,
    PublicMatchOperationV2ActiveSuspensionToJSONTyped,
} from './PublicMatchOperationV2ActiveSuspension';
import type { PublicMatchOperationV2ClockConfiguration } from './PublicMatchOperationV2ClockConfiguration';
import {
    PublicMatchOperationV2ClockConfigurationFromJSON,
    PublicMatchOperationV2ClockConfigurationFromJSONTyped,
    PublicMatchOperationV2ClockConfigurationToJSON,
    PublicMatchOperationV2ClockConfigurationToJSONTyped,
} from './PublicMatchOperationV2ClockConfiguration';
import type { MatchOperationV2State } from './MatchOperationV2State';
import {
    MatchOperationV2StateFromJSON,
    MatchOperationV2StateFromJSONTyped,
    MatchOperationV2StateToJSON,
    MatchOperationV2StateToJSONTyped,
} from './MatchOperationV2State';

/**
 * 
 * @export
 * @interface PublicMatchOperationV2Snapshot
 */
export interface PublicMatchOperationV2Snapshot {
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Snapshot
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Snapshot
     */
    operationMode: PublicMatchOperationV2SnapshotOperationMode;
    /**
     * 
     * @type {PublicMatchOperationV2ClockConfiguration}
     * @memberof PublicMatchOperationV2Snapshot
     */
    _configuration: PublicMatchOperationV2ClockConfiguration;
    /**
     * 
     * @type {PublicMatchOperationV2Participants}
     * @memberof PublicMatchOperationV2Snapshot
     */
    participants: PublicMatchOperationV2Participants;
    /**
     * 
     * @type {MatchOperationV2State}
     * @memberof PublicMatchOperationV2Snapshot
     */
    state: MatchOperationV2State;
    /**
     * 
     * @type {Array<PublicMatchOperationV2ActiveSuspension>}
     * @memberof PublicMatchOperationV2Snapshot
     */
    activeSuspensions: Array<PublicMatchOperationV2ActiveSuspension>;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2Snapshot
     */
    revision: number;
    /**
     * 
     * @type {Date}
     * @memberof PublicMatchOperationV2Snapshot
     */
    serverTime: Date;
}

/**
* @export
* @enum {string}
*/
export enum PublicMatchOperationV2SnapshotOperationMode {
    ResultOnly = 'RESULT_ONLY',
    LiveMatchOperations = 'LIVE_MATCH_OPERATIONS'
}


/**
 * Check if a given object implements the PublicMatchOperationV2Snapshot interface.
 */
export function instanceOfPublicMatchOperationV2Snapshot(value: object): value is PublicMatchOperationV2Snapshot {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('operationMode' in value) || value['operationMode'] === undefined) return false;
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    if (!('participants' in value) || value['participants'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('activeSuspensions' in value) || value['activeSuspensions'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('serverTime' in value) || value['serverTime'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2SnapshotFromJSON(json: any): PublicMatchOperationV2Snapshot {
    return PublicMatchOperationV2SnapshotFromJSONTyped(json, false);
}

export function PublicMatchOperationV2SnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2Snapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'operationMode': json['operationMode'],
        '_configuration': PublicMatchOperationV2ClockConfigurationFromJSON(json['configuration']),
        'participants': PublicMatchOperationV2ParticipantsFromJSON(json['participants']),
        'state': MatchOperationV2StateFromJSON(json['state']),
        'activeSuspensions': ((json['activeSuspensions'] as Array<any>).map(PublicMatchOperationV2ActiveSuspensionFromJSON)),
        'revision': json['revision'],
        'serverTime': (new Date(json['serverTime'])),
    };
}

export function PublicMatchOperationV2SnapshotToJSON(json: any): PublicMatchOperationV2Snapshot {
    return PublicMatchOperationV2SnapshotToJSONTyped(json, false);
}

export function PublicMatchOperationV2SnapshotToJSONTyped(value?: PublicMatchOperationV2Snapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'operationMode': value['operationMode'],
        'configuration': PublicMatchOperationV2ClockConfigurationToJSON(value['_configuration']),
        'participants': PublicMatchOperationV2ParticipantsToJSON(value['participants']),
        'state': MatchOperationV2StateToJSON(value['state']),
        'activeSuspensions': ((value['activeSuspensions'] as Array<any>).map(PublicMatchOperationV2ActiveSuspensionToJSON)),
        'revision': value['revision'],
        'serverTime': value['serverTime'].toISOString(),
    };
}

